import { TOCCHECKBOX} from './tocCheckBoxTypes'

const initialState = {
    checkbox: {
        name: "",
        oggetto: "",
        visible: false,
        opacity: 1
    }
}

const tocCheckBoxReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case TOCCHECKBOX:
            
            return {
                checkbox: action.load
            }
    
        default:
          return state
    }

}


export default tocCheckBoxReducer;